<template>
    <div>
        <ReportTemplate title="Inventory Transaction Report" />
    </div>
</template>

<script>
import SectionTitle from "../../UI/SectionTitle.vue"
import ReportTemplate from "../ReportTemplate.vue"
export default {
    components: { SectionTitle, ReportTemplate },
}
</script>

<style></style>
